import ArrowsArrowRightDownLine from './arrows-arrow-right-down-line.component.js'

export * from './arrows-arrow-right-down-line.component.js'
export default ArrowsArrowRightDownLine

ArrowsArrowRightDownLine.define()

declare global {
  interface HTMLElementTagNameMap {
    'dap-ds-icon-arrow-right-down-line': ArrowsArrowRightDownLine
  }
}
